import { exact, string } from "prop-types";

/** @deprecated use TypeScript interface or type instead */
export const optionType = exact({
  text: string.isRequired,
  value: string.isRequired,
});
